// en, de, fr, pt
export default {
  en: {
    Drivers: 'Drivers',
    Logs: 'Logs',
    Driving: 'Driving Events',
    Vehicles: 'Vehicles',
    ELDs: 'ELDs',
    ELD: 'ELD',
    CompanyProfile: 'Company Profile',
    Reports: 'Reports',
    Groups: 'ELD Groups',
    Transfer: 'Transfer ELD Data',
    Overview: 'Overview',
    Settings: 'Settings',
  },
  uz: {
    Drivers: 'Haydovchilar',
    Logs: 'Jurnallar',
    Driving: 'Haydash tadbirlari',
    Vehicles: 'Yuk mashinalar',
    ELDs: 'ELDlar',
    Groups: 'ELD Jamoalari',
    Transfer: `ELDni uzatish`,
    Overview: 'Umumiy',
    Reports: 'Hisobotlar',
    Settings: 'Settings',
  },
  fr: {
    Drivers: 'Conducteurs',
    Logs: 'Journaux',
    Driving: 'Événements',
    Vehicles: 'Véhicules',
    ELDs: 'ELDs',
    Groups: 'ELD Groupes',
    Transfer: 'Transférer ELD',
    Overview: 'Aperçu',
    Reports: 'Rapports',
    Settings: 'Settings',
  },
  sp: {
    Drivers: 'Conductores',
    Logs: 'Registros',
    Driving: 'Eventos conducción',
    Vehicles: 'Vehículos',
    ELDs: 'ELDs',
    Groups: 'ELD Grupos',
    Transfer: 'Transferir datos ELD',
    Overview: 'Visión de conjunto',
    Reports: 'Informes',
    Settings: 'Settings',
  },
  ru: {
    Drivers: 'Драйверы',
    Logs: 'Журналы',
    Driving: 'События вождения',
    Vehicles: 'Грузовики',
    ELDs: 'ELDs',
    Groups: 'ELD Группы',
    Transfer: 'Передача ELD',
    Overview: 'Обзор',
    Reports: 'Отчеты',
    Settings: 'Settings',
  }
}
